/* SBTWO-4739: the if() wrapper changes Firefox's JS engine behaviour
 * so that $A is not visible in time for some internal Prototype code to
 * find it. Predefining it here fixes things.
 */  
function $A(iterable) {
  if (!iterable) return [];
  if ('toArray' in Object(iterable)) return iterable.toArray();
  var length = iterable.length || 0, results = new Array(length);
  while (length--) results[length] = iterable[length];
  return results;
}

if (typeof Prototype == 'undefined') {

